import date from '@/utils/date';

export const convertTimeStampForServiceTracking = (timestamp: string, serviceStatus: boolean) => {
  if (!timestamp) return null;
  const inputDate = new Date(timestamp);

  const hour = inputDate.getHours();
  const formattedMinute = inputDate.getMinutes().toString().padStart(2, '0');
  const convertedTime = `${hour % 12 === 0 ? 12 : hour % 12}:${formattedMinute} ${
    hour < 12 ? 'AM' : 'PM'
  }`;

  return `${serviceStatus ? convertedTime : ''}, ${date.format(timestamp, { month: 'short' })}`;
};

export const getTrackingStatus = (currentStatus: string | undefined) => {
  return currentStatus !== 'serviceCompleted' ? 'Open' : 'Closed';
};
